/**
 * Find A Home By School Search
 * 
 */
var findAHomeBySchool = new function () {
   var self = this,
      oForm = new PageForm('#PageBody', '/findahomebyschool.c21', 'FindAHomeBySchoolSearch', {}, true, true),
      m_strSchoolSearchParams = null,
      m_iSchoolRowsPerPage = 6,
      m_internationalization = window.internationalization,
      mobileInit = false,
      
      onSearchClear = function () {
         initializeInfiniteScroll();
         $("#schoolSearchResults").scrollTop(0);
         initSchoolDistrictResults();
      },

      getLocationId = function () {
         var locationId = $("#selectedFAHLocationID").val();
         return locationId;
      },

      /**
       * Initialize Infinite Scroll of School Search Results
       * 
       */
      initializeInfiniteScroll = function () {
         if (!isFullPage()) {
            return;
         }

         var jContent = $("#schoolSearchResults").infinitescroll({
               triggerAt: 300,
               page: 1,
               dataHandler: function (infiniteScroll) {
                  showLoadingMore();

                  var iStart = (infiniteScroll.page * m_iSchoolRowsPerPage);
                  
                  $.ajax({
                        url: "/findahomebyschool.c21",
                        data: getParams(iStart),
                        dataType: "json",
                        success: function (data) {
                           // Must use a <div />, because sometimes
                           // data.window comes back as
                           // an empty string, and Sizzle.js doesn't like
                           // that
                           var jResults = $("<div />").html(data.findahomeschoolresults);
                           jContent.append(jResults);
                           initSchoolDistrictResults();

                           hideLoadingMore();

                           $("#noSchoolResults").hide();

                           if (!isFullPage(jResults)) {
                              infiniteScroll.setReachedEnd();
                           } else {
                              infiniteScroll.reset();
                           }
                        }
                     });
               }
            });
      },

      /**
       * Look at number of results and return whether this is a full page
       */
      isFullPage = function (jParent) {
         var jContainer = (jParent) ? jParent : $("#schoolSearchResults"),
            iRecords = jContainer.find(".schoolRecord").length;

         if (iRecords === 0) {
            return false;
         } else {
            return ((iRecords % m_iSchoolRowsPerPage) === 0);
         }
      },

      /**
       * Show Loading Indicator
       * 
       */
      showLoadingMore = function () {
         $("#schoolSearchResults").append(
            "<div id='loadingMore'>Loading...</div>");
      },

      /**
       * Hide Loading Indicator
       * 
       */
      hideLoadingMore = function () {
         $("#loadingMore").remove();
      },

      getSchoolId = function (jSchoolCheckbox) {
         var strId = jSchoolCheckbox.attr("id"),

            // Get the school ID
            strSchoolId = strId.substr(15);

         return strSchoolId;
      },

      /**
       * Remove string value from comma seperated values of element
       */
      removeStringFromElement = function (jElement, strToRemove) {
         var strList = jElement.val(),
            strNewList = removeFromStringList(strList, strToRemove);

         jElement.val(strNewList);
         return strNewList;
      },

      isStringInElement = function (jElement, str) {
         var strList = jElement.val(),
            bIsStringInList = isStringInList(strList, str);

         return bIsStringInList;
      },

      /**
       * Add string value to comma seperated values of element
       */
      addStringToElement = function (jElement, strToAdd) {
         var strList = jElement.val(),
            strNewList = addToStringList(strList, strToAdd);

         jElement.val(strNewList);
         return strNewList;
      },

      /**
       * Add String to List
       * 
       */
      addToStringList = function (strList, strToAdd) {
         if (strList == null || strList == "") {
            strList = strToAdd;
         } else {
            strList = strList + "," + strToAdd;
         }
         return strList;
      },

      /**
       * Remove String from List
       * 
       */
      removeFromStringList = function (strList, strToRemove) {
         if (strList) {
            if (strList.indexOf(strToRemove + ",") != -1) {
               strList = strList.replace(strToRemove + ",", "");
            } else if (strList.indexOf("," + strToRemove) != -1) {
               strList = strList.replace("," + strToRemove, "");
            } else {
               strList = strList.replace(strToRemove, "");
            }
         }
         return strList;
      },

      isStringInList = function (strList, str) {
         var bInList = false;
         if (str) {
            if (jQuery.inArray(str, strList.replace(/,\s+/g, ',').split(',')) >= 0) {
               bInList = true;
            }
         }
         return bInList;
      },

      getParams = function (iStart) {
         var oFormParams = oForm.getQueryParameters(),
            oParams = $.extend({
               start: iStart.toString(),
               rpp: m_iSchoolRowsPerPage,
               sortby: $("#schoolSortTypes").val(),
               lid: getLocationId(),
               submitted: true,
               subView: "loadSchoolSearchResults"
            }, oFormParams),
            strParams = $.param(oParams);

         return strParams;
      },

      /**
       * Filter by School Grades
       * 
       */
      onGradesChange = function() {
     	 Track.doEvent('Find a Home', 'Search By School', 'Filter by Grade Level'); 
      },
      
      /**
       * Filter by Student Teacher Ratio
       * 
       */
      onStudentTeacherRatioChange = function() {
     	 Track.doEvent('Find a Home', 'Search By School', 'Filter by Student/Teacher Ratio'); 
      },

      /**
       * Filter by Number of Students
       * 
       */
      onStudentsTotalChange = function() {
     	 Track.doEvent('Find a Home', 'Search By School', 'Filter by Total # of Students'); 
      },
      
      /**
       * Initialize the School District Results
       * 
       */
      initSchoolDistrictResults = function () {
         var jCheckboxes = $("#schoolSearchResults .schoolCheckbox:not(.initialized)"),
            jResults = $("#schoolSearchResultsSection"),
            jNoResults = $("#noSchoolSearchResultsSection"),
            jSelected = $("#selectedSchoolIds");
            
         jResults.show();

         jCheckboxes
            .each(function () {
               var jThis = $(this),
                  strSchoolId = getSchoolId(jThis);

               if (isStringInElement(jSelected, strSchoolId)) {
                  jThis.prop("checked", true);
               }
            })
            .click(function () {
               var jThis = $(this),
                  strSchoolId = getSchoolId(jThis);

               if (jThis.prop("checked")) {
            	  Track.doEvent("Find a Home", "Search By School", "Include Homes for School", parseInt(strSchoolId.substring(1)));  
                  addStringToElement(jSelected, strSchoolId);
               } else {
            	  Track.doEvent("Find a Home", "Search By School", "Exclude Homes for School", parseInt(strSchoolId.substring(1))); 
                  removeStringFromElement(jSelected, strSchoolId);
               }
            })
            .uniform()
            .addClass("initialized");

         // Check if there are no school results - display no results message
         var strSchoolResults = $("#schoolResultsCount").val(),

            // Will be NaN if strSchoolResults is null
            iSchoolResults = parseInt(strSchoolResults);

         if (iSchoolResults > 0) {
            jResults.show();
            jNoResults.hide();
         } else {
            jResults.hide();
            jNoResults.show();
         }
      };


   /**
    * Initialize School Search
    * 
    */
   self.initialize = function () {
      // Mobile      
	  self.initMobile();
      $(window).on('enterResponsivePhone', function() {  
         self.initMobile();	  
         mobileInit = true;
      });      
	   
      self.setSearchTab();
      $("#findAHomeBySchoolBody input:checkbox, #findAHomeBySchoolBody input:radio").uniform();
      findAHome.initC21HoverState();
      findAHome.updateC21HoverState();
      findAHome.initializeAutocomplete(self.searchSchools);
      self.initSchoolFeatures();
      self.initRefineDropDowns();
      self.initSchoolSortTypes();      
   }
   
   /**
    * Initialize Mobile only
    * 
    */
   self.initMobile = function () {		 
	  if(window.responsiveMode.getMode() != 1) {
		  return;  
	  } 
	   
	  if($("#showMobileSchoolFeatures").val() != 'Y') {
	     $(".refineTab.featureTypes").addClass('collapse');
	     $("#findASchoolFeaturesSearch").hide();
	  } 	   
	   
	  // do not initialize click if already initialized
	  if(mobileInit) {
		  return;
	  }
	  
	  $(".refineTab.featureTypes").click(function() {
	     if($(this).hasClass('collapse')) {
	        $(this).removeClass('collapse');     
	        $("#findASchoolFeaturesSearch").show();
	        $("#showMobileSchoolFeatures").val("Y");
		 } else {
	        $(this).addClass('collapse');
	        $("#findASchoolFeaturesSearch").hide();
	        $("#showMobileSchoolFeatures").val("N");
		 }
	  });	
	  
	  mobileInit = true;
   };

   /**
    * Set the School Search Tab
    * 
    */
   self.setSearchTab = function () {
      $("#findAHomeSearchTabs .searchTab.byschool, #findAHomeSearchNav .searchBySchool").addClass("selected");
   };

   /**
    * Search and Find a school
    * 
    */
   self.searchSchools = function () {
	  var schoolName = $("#schoolName").val();
	  if(schoolName != null && schoolName != "") {
	     Track.doEvent("Find a Home", "Search By School", "Filter By School Name"); 
	  }
	  
	  if($("#location").val() != null && $("#location").val() != "") {
	     Track.doEvent("Find a Home", "Search By School", "Find Schools"); 
	  }
	  
      $("#schoolSortTypes").val("gsrating-desc");
      $.uniform.update();
      oForm.submit({
         cache: true,
         callback: onSearchClear
      });
   };

   /**
    * Clear School Search Criteria
    * 
    */
   self.clearSchoolSearch = function () {
	  Track.doEvent("Find a Home", "Search By School", "Clear Search Criteria");  
      oForm.clear();
      $("#selectedSchoolIds").val("");
      $("#selectedSchoolFlags").val("");
      $("#fahstudentratio").c21dropdown("setValue", "", "");
      $("#fahstudents").c21dropdown("setValue", "", "");
      findAHome.updateC21HoverState();
      $.uniform.update();
      $("#schoolSearchResultsSection").hide();
      $("#noSchoolSearchResultsSection").show();
   };

   /**
    * Initialize School Features
    * 
    */
   self.initSchoolFeatures = function () {
      $("#findASchoolFeaturesSearch").css("border-bottom", "none");
      $("#findASchoolFeaturesSearch .collapsableHeader").css("height", "36px");
      $("#findASchoolFeaturesSearch .actionHeader, #findASchoolFeaturesSearch .actionImage").click(function () {
         if ($("#findASchoolFeaturesSearch .collapsableHeader").hasClass("collapse")) {
        	Track.doEvent("Find a Home", "Search By School", "Collapse Features");   
            $("#findASchoolFeaturesSearch .collapsableHeader").removeClass("collapse");
            $("#findASchoolFeaturesSearch .collapsableHeader").addClass("expand");
            $("#findASchoolFeaturesSearch .actionHeader").html(m_internationalization.getString("Expand Features"));
            $("#findASchoolFeaturesSearch .featureList").hide();
            $("#findASchoolFeaturesSearch .findSchoolBtm").hide();
            $("#findASchoolFeaturesSearch").css("border-bottom", "none");
            $("#findASchoolFeaturesSearch .collapsableHeader").css("height", "36px");
         } else {
        	Track.doEvent("Find a Home", "Search By School", "Expand Features"); 
            $("#findASchoolFeaturesSearch .collapsableHeader").removeClass("expand");
            $("#findASchoolFeaturesSearch .collapsableHeader").addClass("collapse");
            $("#findASchoolFeaturesSearch .actionHeader").html(m_internationalization.getString("Collapse Features"));
            $("#findASchoolFeaturesSearch .featureList").show();
            $("#findASchoolFeaturesSearch .findSchoolBtm").show();
            $("#findASchoolFeaturesSearch").css("border-bottom", "1px solid #ddd");
            $("#findASchoolFeaturesSearch .collapsableHeader").css("height", "35px");
         }
      });

      $("#findASchoolFeaturesSearch .schoolFlagCheckbox").click(function () {
         var jFlags = $("#selectedSchoolFlags"),
            selectedFlags = jFlags.val(),
            strElementId = $(this).attr("id"),

            // Get the flag ID
            flagid = strElementId.substr(11);

         if (!$(this).attr("checked")) {
        	Track.doEvent("Find a Home", "Search By School", "Deselect Feature: " + flagid); 
            removeStringFromElement(jFlags, flagid);
         } else {
        	Track.doEvent("Find a Home", "Search By School", "Select Feature: " + flagid);   
            addStringToElement(jFlags, flagid);
         }
      });
   };

   /**
    * Initialize School Search Refine Drop Downs
    * 
    */
   self.initRefineDropDowns = function () {
      $('#fahschooltypes, #fahschoolgrades, #fahgsrating, #fahparentrating').uniform({
            selectClass: 'selector smallSelector'
         });

      $("#fahstudents").c21dropdown({
            maxLength: 4,
            onBlur : onStudentsTotalChange,
            dropdownClass: 'fahdropdownCustomizations',
            selectBoxClass: 'fahselectorCustomizations',
            baseName: 'fahstudents',
            selectedVal: 'max'
         });

      $("#fahstudentratio").c21dropdown({
            maxLength: 3,
            onBlur : onStudentTeacherRatioChange,
            dropdownClass: 'fahdropdownCustomizations',
            selectBoxClass: 'fahselectorCustomizations',
            baseName: 'fahstudentratio',
            selectedVal: 'max'
         });
      
      // Add GA Trackers
      $('#fahschooltypes').change(function () {
    	var schoolType = $('#fahschooltypes').val();
    	if(schoolType == null || schoolType == "") {
    		schoolType = "Any";	
    	}
     	Track.doEvent("Find a Home", "Search By School", "Filter By School Type: " + schoolType.substr(0, 1).toUpperCase() + schoolType.substr(1)); 
      });	
   };

   /**
    * Initialize the sort types
    * 
    */
   self.initSchoolSortTypes = function () {
      var jSortTypes = $("#schoolSortTypes")

      jSortTypes
         .uniform()
         .change(function () {
        	Track.doEvent("Find a Home", "Search By School", "Sort By: " + jSortTypes.val());  
            portalAjax.doViewEngineAjax('loadSchoolSearchResults',
               "/findahomebyschool.c21", getParams(0), {
                  cache: true,
                  callback: onSearchClear
               });
         });
   };

   /**
    * Property Search with selected schools
    * 
    */
   self.searchHomes = function () {
	  if(getLocationId() != null && getLocationId() != "") {
	     Track.doEvent("Find a Home", "Search By School", "Find Homes: " + getLocationId()); 
	  }
	      
      var locationId = getLocationId(),
         selectedSchools = $("#selectedSchoolIds").val(),
         propertySearchParams = $.param({
               selectedschoolids: selectedSchools,
               lid: locationId
            });

      // Perform Search AJAX
      portalAjax.doViewEngineAjax('searchHomesBySchools',
         "/findahomebyschool.c21", propertySearchParams, {
            cache: true,
            callback: function () {}
         });
   };
};
